import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["labelPath"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { DefaultPagesVisibilityMap, PagesVisibilityMap } from "@Client/@Utils/application/pages-visibility-map";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { ref, watch } from "@vue/composition-api";
import { isEmpty } from "lodash";
export const useApplicationVisibilityState = () => {
  const {
    GET_CURRENT_SCHEMA,
    GET_CURRENT_FLOW,
    PAGES_TO_FILL_OUT,
    IS_FILL_OUT,
    MORTGAGE_DETAILS_REQUESTED,
    PROPERTY_REQUESTED,
    CO_APPLICANTS_LENGTH
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_CURRENT_SCHEMA, ApplicationStandaloneGetters.GET_CURRENT_FLOW, ApplicationStandaloneGetters.PAGES_TO_FILL_OUT, ApplicationStandaloneGetters.IS_FILL_OUT, ApplicationStandaloneGetters.MORTGAGE_DETAILS_REQUESTED, ApplicationStandaloneGetters.PROPERTY_REQUESTED, ApplicationStandaloneGetters.CO_APPLICANTS_LENGTH]);
  const visibilityState = ref([]);
  const updateVisibilityState = () => {
    let states = [];
    if (isEmpty(GET_CURRENT_SCHEMA.value)) {
      states = _mapInstanceProperty(DefaultPagesVisibilityMap).call(DefaultPagesVisibilityMap, _ref => {
        let {
            labelPath
          } = _ref,
          pageVisibilityMap = _objectWithoutProperties(_ref, _excluded);
        return _objectSpread(_objectSpread({}, pageVisibilityMap), {}, {
          label: labelPath
        });
      });
    } else {
      states = _mapInstanceProperty(PagesVisibilityMap).call(PagesVisibilityMap, ({
        paths,
        section,
        labelPath
      }) => {
        var _context;
        return {
          name: section,
          visible: _includesInstanceProperty(_context = PAGES_TO_FILL_OUT.value).call(_context, section) && paths.some(path => {
            var _GET_CURRENT_FLOW$val;
            if (path === "always") return true;
            const isGoalsVisible = section !== APPLICATION_STEPS.GOALS || MORTGAGE_DETAILS_REQUESTED.value && _includesInstanceProperty(path).call(path, "mortgage-details") || PROPERTY_REQUESTED.value && _includesInstanceProperty(path).call(path, "property");
            const isPathForMainApplicant = _includesInstanceProperty(path).call(path, "main-applicant");
            const isPathForCoapps = _includesInstanceProperty(path).call(path, "co-applicants");
            const thereAreCoapps = !!CO_APPLICANTS_LENGTH.value;
            const visibleFromFillOut = !IS_FILL_OUT.value || isGoalsVisible && !isPathForMainApplicant;
            const visibleFromSchema = GET_CURRENT_SCHEMA.value[path].visible[(_GET_CURRENT_FLOW$val = GET_CURRENT_FLOW.value) != null ? _GET_CURRENT_FLOW$val : "purchase-approval"];
            if (isPathForCoapps) {
              return thereAreCoapps && visibleFromFillOut && visibleFromSchema;
            }
            return visibleFromFillOut && visibleFromSchema || !IS_FILL_OUT.value && section === APPLICATION_STEPS.GOALS;
          }),
          paths,
          label: labelPath
        };
      });
    }
    visibilityState.value = _filterInstanceProperty(states).call(states, state => state.visible);
  };
  watch(CO_APPLICANTS_LENGTH, () => {
    updateVisibilityState();
  });
  watch(GET_CURRENT_FLOW, (currentFlow, oldFlow) => {
    if (currentFlow === oldFlow) return;
    updateVisibilityState();
  }, {
    immediate: true
  });
  watch([GET_CURRENT_SCHEMA, PAGES_TO_FILL_OUT], () => {
    updateVisibilityState();
  }, {
    immediate: true
  });
  return {
    visibilityState
  };
};